import axios from 'axios'

// initial state
const state = () => ({
    syndromeQuestionnaires: null,
    currentSyndromeQuestionnaireIndex: 0,
    currentSyndromeQuestionnaire: null,
    currentSectionIndex: 0,
    currentSection: null,
    showNextSectionButton: false,
    showNextQuestionnaireButton: false,
    showSubmitButton: false
})
  

// getters
const getters = {
    syndromeQuestionnaires: state => {
        return state.syndromeQuestionnaires;
    },
    currentSyndromeQuestionnaire: state => {
        return state.currentSyndromeQuestionnaire;
    },
    currentSection: state => {
        return state.currentSection;
    },
    currentSectionIndex: state => {
        return state.currentSectionIndex;
    },
    showNextSectionButton: state => {
        return state.showNextSectionButton;
    },
    showNextQuestionnaireButton: state => {
        return state.showNextQuestionnaireButton;
    },
    showSubmitButton: state => {
        return state.showSubmitButton;
    },
    currentSyndromeQuestionnaireIndex: state => {
        return state.currentSyndromeQuestionnaireIndex;
    },
    currentQuestionnaireTitle: state => {
        if(state.currentSyndromeQuestionnaire == null) {
            return 'Questionnaire';
        } 
        
        return {
            title: state.currentSyndromeQuestionnaire.questionnaire.content.replace("{{SYNDROME}}", "'"+state.currentSyndromeQuestionnaire.syndromeObject.label+"'"),
            title_zh:state.currentSyndromeQuestionnaire.questionnaire.content_zh.replace("{{SYNDROME}}", "'"+state.currentSyndromeQuestionnaire.syndromeObject.label_zh+"'")
        }
    }

}


// actions
const actions = {
    async createSyndromeQuestionnaires({commit}, assessment) {
        // Create and array of questionnaireObjects which contain the syndrome and
        // questionnaire
        let syndromeQuestionnaires = [];
        let syndromeObjects = assessment.syndromeObjects;

        for(const syndromeObject of syndromeObjects) {
            let questionnaireObject = {};
            questionnaireObject.syndromeObject = syndromeObject;
            questionnaireObject.questionnaire = this.state.questionnaire.questionnaire;

            syndromeQuestionnaires.push(questionnaireObject);
        }

        // Put a result field in each section
        if(this.state.questionnaire.questionnaire != null) {
            for(const syndromeQuestionnaireObject of syndromeQuestionnaires) {
                for(const section of syndromeQuestionnaireObject.questionnaire.sections) {
                    section.result = null;
                }
            }
        }

        // Send this object off to the backend where we can fetch the results from the syndrome_questionnaire table
        let syndromeQuestionnairesWithResults = await axios.post('/syndromequestionnaire', {syndromeQuestionnaires, assessmentID: assessment.id});

        commit('SET_SYNDROME_QUESTIONNAIRES', syndromeQuestionnairesWithResults.data);       
        commit('SET_CURRENT_SYNDROME_QUESTIONNAIRE');       
        commit('SET_CURRENT_SECTION');
        commit('SET_SHOW_NEXT_SECTION_BUTTON', true);       
    },
    incrementCurrentSection({commit, state}) {
        if(state.currentSectionIndex < state.currentSyndromeQuestionnaire.questionnaire.sections.length - 1) {
            commit('INCREMENT_CURRENT_SECTION_INDEX'); // This line increase the currentSecitonIndex by 1
    
            // Checking if we are a the end of the currentSection
            if(state.currentSectionIndex == state.currentSyndromeQuestionnaire.questionnaire.sections.length - 1) {
                
                // Check if we are at the end of the total questionnaire
                // Set the last section and disable all buttons besides the submit button
                if(state.currentSyndromeQuestionnaireIndex == state.syndromeQuestionnaires.length - 1) {
                    commit('SET_CURRENT_SECTION'); 
                    commit('SET_SHOW_NEXT_SECTION_BUTTON', false);      
                    commit('SET_SHOW_NEXT_QUESTIONNAIRE_BUTTON', false);
                    commit('SET_SHOW_SUBMIT_BUTTON', true);

                    return;
                }

                commit('SET_SHOW_NEXT_SECTION_BUTTON', false);      
                commit('SET_SHOW_NEXT_QUESTIONNAIRE_BUTTON', true);
            }
        }     

        commit('SET_CURRENT_SECTION'); 
    },
    incrementCurrentSyndromeQuestionnaire({commit, state}) {
        if(state.currentSyndromeQuestionnaireIndex < state.syndromeQuestionnaires.length - 1) {
            commit('INCREMENT_CURRENT_SYNDROME_QUESTIONNAIRE_INDEX');     
        }

        // Once we get to a new seciton we want to reset the section inside the index and set the current section
        // along with the new questionnaire
        commit('SET_CURRENT_SYNDROME_QUESTIONNAIRE');
        commit('RESET_CURRENT_SECTION_INDEX');
        commit('SET_CURRENT_SECTION'); 

        // Turn on next section button and turn off next questionnaire button
        commit('SET_SHOW_NEXT_SECTION_BUTTON', true);      
        commit('SET_SHOW_NEXT_QUESTIONNAIRE_BUTTON', false);
    },
    async storeSyndromeQuestionnaireResult({commit, state}, data) {
        data.syndrome_id = state.currentSyndromeQuestionnaire.syndromeObject.value;
        data.questionnaire_section_id = state.currentSection.id;

        await axios.post('/syndromequestionnaire/save', data);
        

        commit('UPDATE_SYNDROME_QUESTIONNAIRE_SECTION_RESULT', data.result);
    }
}
  
// mutations
const mutations = {
    SET_SYNDROME_QUESTIONNAIRES: (state, syndromeQuestionnaires) => {
        state.syndromeQuestionnaires = syndromeQuestionnaires;
    },
    UPDATE_SYNDROME_QUESTIONNAIRE_SECTION_RESULT: (state, val) => {
        state.syndromeQuestionnaires[state.currentSyndromeQuestionnaireIndex].questionnaire.sections[state.currentSectionIndex].result = val;
    },
    SET_CURRENT_SYNDROME_QUESTIONNAIRE: (state) => {
        state.currentSyndromeQuestionnaire = state.syndromeQuestionnaires[state.currentSyndromeQuestionnaireIndex];
    },
    SET_CURRENT_SECTION: (state) => {
        state.currentSection = state.currentSyndromeQuestionnaire.questionnaire.sections[state.currentSectionIndex];
    },
    INCREMENT_CURRENT_SECTION_INDEX: (state) => {
        state.currentSectionIndex = state.currentSectionIndex + 1;
    },
    RESET_CURRENT_SECTION_INDEX: (state) => {
        state.currentSectionIndex = 0;
    },
    INCREMENT_CURRENT_SYNDROME_QUESTIONNAIRE_INDEX: (state) => {
        state.currentSyndromeQuestionnaireIndex = state.currentSyndromeQuestionnaireIndex + 1;
    },
    RESET_CURRENT_SYNDROME_QUESTIONNAIRE_INDEX: (state) => {
        state.currentSyndromeQuestionnaireIndex = 0;
    },
    SET_SHOW_NEXT_SECTION_BUTTON: (state, val) => {
        state.showNextSectionButton = val;
    },
    SET_SHOW_NEXT_QUESTIONNAIRE_BUTTON: (state, val) => {
        state.showNextQuestionnaireButton = val;
    },
    SET_SHOW_SUBMIT_BUTTON: (state, val) => {
        state.showSubmitButton = val;
    }
}
  

export default {
    state,
    getters,
    actions,
    mutations
}